import React, { useState, useEffect } from "react";
import { Divider, Skeleton, Avatar, Space, Row, Col } from "antd";
import { UserOutlined, SettingOutlined } from "@ant-design/icons";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
import SideExpendituresForm from "./form";

const GETSIDEEXPENDITURE = gql`
  query ($id: ID!) {
    getExpenditure(id: $id) {
      createdAt
      updatedAt
      documentImg
      amount
      description
      occurrenceAt
    }
  }
`;

function SideExpendituresTableDetails({ id, onCloseDrawer, onDataUpdate }) {
  const [initialData, setInitialData] = useState({});

  const [formData, setFromData] = useState(null);

  const [getExpenditureData, expenditureData] = useLazyQuery(
    GETSIDEEXPENDITURE,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getExpenditure }) {
        const expenditureData = {
          occurrenceAt:
            getExpenditure?.occurrenceAt &&
            moment(getExpenditure?.occurrenceAt),
          amount: getExpenditure?.amount,
          description: getExpenditure?.description,
          documentImg : getExpenditure?.documentImg
        };
        setFromData(expenditureData);
        const { description, createdAt, updatedAt, occurrenceAt, amount } =
          getExpenditure;
        setInitialData({
          description,
          amount,
          createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
          updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
          occurrenceAt:
            occurrenceAt && moment(occurrenceAt).format("jYYYY/jMM/jDD"),
        });
      },
    }
  );
  useEffect(() => {
    if (id) {
      getExpenditureData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const expenditureDataUpdated = () => {
    getExpenditureData({
      variables: {
        id,
      },
    });
  };

  const { createdAt, updatedAt } = initialData;

  if (expenditureData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Divider style={{ fontWeight: 700 }} orientation="right">
        اطلاعات هزینه
      </Divider>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
      <SideExpendituresForm
        formData={formData}
        expenditureId={id}
        onDoUpdateData={onDataUpdate}
      />
    </>
  );
}

export default SideExpendituresTableDetails;
